var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { INICIALIZAR, CONFIGURACION_PAGINA_CARGADA } from '../actions';
export default function paginasLibros() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.paginas;

    case CONFIGURACION_PAGINA_CARGADA:
      var newPaginas = _extends({}, state);

      newPaginas[action.libroId][action.numPagina] = action.data;
      return newPaginas;

    default:
      return state;
  }
}